import { useEffect, useState } from 'react';
import { verificationAPI } from '../utils/api';

/**
 * 간편인증(면허정보 조회)을 쓸 수 있는지 서버에 묻는다. 확인 전·실패 시에는 false —
 * 실제 조회 수단이 없을 때 주민등록번호 뒤 7자리를 받는 일이 없도록 기본값을 '숨김'으로 둔다.
 */
export function useSimpleAuthEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let alive = true;
    verificationAPI
      .config()
      .then((res) => {
        if (alive) setEnabled(Boolean(res.data?.simpleAuth));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return enabled;
}
